// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonGoBack_button__1HdTh"};